import { render, staticRenderFns } from "./RoyaltyIncentiveKits.vue?vue&type=template&id=429cedb0&"
import script from "./RoyaltyIncentiveKits.vue?vue&type=script&lang=js&"
export * from "./RoyaltyIncentiveKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports